import { httpRequest } from "@services/http";
import { normalizeLinkState, type LaunchNetworkLinks } from "@models/launchNetworkLinks.model";

export class CommandGetLaunchNetworkLinks {
  async run(launchId: number, network: string): Promise<LaunchNetworkLinks> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/networks/${network.toLowerCase()}/links/`;
    const data = await httpRequest<LaunchNetworkLinks>(url, { method: "GET" });
    return {
      ...data,
      campaign: data.campaign ? normalizeLinkState(data.campaign) : null,
      audiences: data.audiences.map(normalizeLinkState),
      ad_groups: data.ad_groups.map(normalizeLinkState),
      ads: data.ads.map(normalizeLinkState),
    };
  }
}
